import { LogInput } from 'noddi-util';
import { log } from 'noddi-web';
import { useEffect } from 'react';
import { ErrorPageBase } from './ErrorPageBase';
import { ErrorPageBaseProps } from './types';

export const ErrorPage = ({
  title,
  description,
  buttonProps,
  logInput
}: ErrorPageBaseProps & {
  logInput: LogInput;
}) => {
  useEffect(() => {
    log(logInput);
  }, [logInput]);
  return <ErrorPageBase title={title} description={description} buttonProps={buttonProps} />;
};
